import { render, staticRenderFns } from "./GlobalAddEdit.vue?vue&type=template&id=c256311e"
import script from "./GlobalAddEdit.vue?vue&type=script&lang=js"
export * from "./GlobalAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports